import Vue from 'vue';
import store from './../../store';
import projectTransformer from './../../transformers/project';

const success = ({ data }, resolve) => {
  const projects = projectTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllProjects', projects);
  resolve(projects);
};

const failed = (error, reject) => reject(error);


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/projects')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/project/all.js